import TriumphLogo from '../assets/images/TFin.png';
import CHRobinsonLogo from '../assets/images/chr.png';
import RXOLogo from '../assets/images/rxo.png';

export enum CompanyId {
    'Triumph Factoring' = 1,
    'C.H. Robinson Factoring by Triumph' = 3,
    'RXO Extra | Factoring' = 4
}

export interface CompanyConfig {
    backgroundColor: string;
    foregroundColor: string;
    iconSrc: string;
}

export interface Company {
    id: CompanyId;
    name: string;
    config: CompanyConfig;
}

export const CompanyConfigs: Record<number, CompanyConfig> = {
    1: {
        backgroundColor: '#1E7843',
        foregroundColor: '#FFFFFF',
        iconSrc: TriumphLogo
    },
    3: {
        backgroundColor: '#30859E',
        foregroundColor: '#FFFFFF',
        iconSrc: CHRobinsonLogo
    },
    4: {
        backgroundColor: '#000000',
        foregroundColor: '#FFFFFF',
        iconSrc: RXOLogo
    }
};

export const getCompanyConfig = (id: number): CompanyConfig => {
    return CompanyConfigs[id] || CompanyConfigs[1]; // Default to Triumph
};

export const createCompany = (id: number): Company => ({
    id: id as CompanyId,
    name: CompanyId[id] || `Company ${id}`,
    config: getCompanyConfig(id)
});
